module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sr-f281cc96dc94e9f2bcdf35155d700dfa.svg";